import script from "./PortfolioTradeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioTradeTable.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioTradeTable.vue?vue&type=style&index=0&id=049c955e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049c955e"]])

export default __exports__